import { AxiosInstance } from "axios"
import { EditFeatureBody, SupportFeature } from "./featuresTypes"
import { ServiceResponse } from "../../../../core/api/apiTypes"

export enum SupportFeaturesQuery {
    LIST = "support-features-list",
    DETAILS = "support-feature-details",
}

export type FetchSupportFeaturesResponse = Readonly<{
    features: Array<SupportFeature>
}>

export async function fetchSupportFeatures(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSupportFeaturesResponse> {
    const response = await axios.get("/features", {
        signal,
    })

    return response.data
}

export type FetchSupportFeatureDetailsResponse = Readonly<{
    feature: SupportFeature
}>

export async function fetchSupportFeatureDetails(
    { featureId }: { featureId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSupportFeatureDetailsResponse> {
    const response = await axios.get(`/features/${featureId}`, {
        signal,
    })

    return response.data
}

export type ChangeFeatureStatusParams = Readonly<{
    featureId: number
    isEnabled: boolean
}>

export async function changeFeatureStatus(
    { featureId, isEnabled }: ChangeFeatureStatusParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/features/${featureId}`

    const response = await axios.post(
        url,
        {
            isEnabled,
        },
        {
            signal,
        },
    )

    return response.data
}

export type EditFeatureParams = Readonly<{
    featureId: string
    feature: EditFeatureBody
}>

export async function editFeature(
    { featureId, feature }: EditFeatureParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/features/${featureId}`

    const response = await axios.post(
        url,
        {
            ...feature,
        },
        {
            signal,
        },
    )

    return response.data
}
